import { favoritesManager } from '../Stores/FavoritesManager'
// import { userManager } from '@/Core/Managers'
import { restClient } from '@/Core'

interface LoadFavoritesListTaskParams {
    searchParams?: {
        page?: number
        entityUuid?: string
        [key: string]: any
    }
    onCheckFavorite?: (params: { isInFavorites: boolean; favoriteUuid: string | null }) => void
    showError?: (message?: string, description?: string) => void
    // showSuccess?: (message?: string, description?: string) => void
}

export const LoadFavoritesListTask = async ({
    searchParams = {},
    onCheckFavorite,
    showError,
    // showSuccess,
}: LoadFavoritesListTaskParams = {}) => {
    const page = searchParams.page ?? 1

    if (favoritesManager.isFavoritesLoading) return

    favoritesManager.setIsFavoritesLoading(true)
    favoritesManager.setIsLoadingFirstPage(page === 1)

    try {
        const { entityUuid, ...restParams } = searchParams

        const normalizedSearchParams =
            typeof entityUuid === 'string'
                ? {
                      ...restParams,
                      filters: JSON.stringify({
                          and: [
                              {
                                  field: 'entityUuid',
                                  op: '=',
                                  value: entityUuid,
                              },
                          ],
                      }),
                  }
                : restParams

        const response = await restClient.get('/services/user/favorites', {
            searchParams: normalizedSearchParams,
        })

        if (typeof entityUuid === 'string') {
        }

        const items = response?.items || []
        const meta = response?.meta

        if (typeof entityUuid === 'string' && typeof onCheckFavorite === 'function') {
            const favorite = items.find((item) => item.entityUuid === entityUuid)

            onCheckFavorite({
                isInFavorites: Boolean(favorite),
                favoriteUuid: favorite?.uuid ?? null,
            })

            return
        }

        if (Array.isArray(items)) {
            if (page > 1) {
                favoritesManager.appendFavorites(items)
            } else {
                favoritesManager.setFavorites(items)
            }
        }

        if (meta) {
            favoritesManager.setPagination({
                page: meta.page,
                limit: meta.limit,
                total: meta.total,
            })
        }
    } catch (error) {
        console.warn('LoadFavoritesListTask error:', error)
        showError?.('Помилка', 'Не вдалося завантажити список обраного')
    } finally {
        favoritesManager.setIsFavoritesLoading(false)
        favoritesManager.setIsLoadingFirstPage(false)
    }
}
